import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromEmployees from "../reducers/employee.reducer";

export const getAllEmployees = createSelector(fromFeature.getGibState, (state: fromFeature.GibState) => state.employeeState.employees);
export const getAllTrainersFromAssignment = createSelector(fromFeature.getGibState, (state: fromFeature.GibState) => state.employeeState.trainerForAssignment);
export const getRoleValueLabels= createSelector(fromFeature.getGibState, (state: fromFeature.GibState) => state.employeeState.roles);
